
import Vue from "vue";
import store from "@/store"; // store

export default Vue.extend({
  computed: {
    categories: {
      get() {
        return store.getters.getCategories;
      },
    },
  },
  methods: {
    inputValue(value: string) {
      store.dispatch("filterby", value);
    },
  },
});
